var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 202,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 147,
    height: 147,
    x: 27,
    y: 27,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M63.88 163.59a72.95 72.95 0 1 0 72.94-126.34A72.95 72.95 0 1 0 63.88 163.6Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF6D00",
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71.7-14.9 1.58.91-77.5 134.24-1.58-.91L71.7-14.9Zm9.48 5.47 1.58.92-77.5 134.23-1.58-.91L81.18-9.43Zm8.69 5.02 1.58.91-77.5 134.24-1.58-.92L89.87-4.4Zm9.48 5.47 1.58.91-77.5 134.24-1.58-.91L99.35 1.06Zm9.47 5.47 1.58.92-77.5 134.23-1.58-.91 77.5-134.24Zm8.69 5.02 1.58.91L41.6 146.7l-1.58-.91 77.5-134.24Zm9.49 5.47 1.57.92-77.5 134.23-1.58-.91L127 17.02Zm9.47 5.48 1.58.9-77.5 134.24-1.58-.91 77.5-134.23Zm8.69 5.01 1.58.91-77.5 134.24-1.58-.91 77.5-134.24Zm9.48 5.47 1.58.92-77.5 134.23-1.58-.91 77.5-134.24Zm9.47 5.48 1.58.9L88.2 173.6l-1.58-.9 77.5-134.24Zm7.9 4.56 1.58.9-77.5 134.24-1.58-.9 77.5-134.24Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineCircle);
export default __webpack_public_path__ + "static/media/line-circle.a9deec5d0064b3614759f85903991fec.svg";
export { ForwardRef as ReactComponent };